import axios from "axios";
import { API } from "./client";

// ── Management Items ─────────────────────────────────────────────────────────

export async function getManagementItems(projectId, type = null, status = "open") {
  const params = { status };
  if (type) params.type = type;
  const res = await axios.get(`${API}/projects/${projectId}/management`, { params });
  return res.data;
}

export async function createManagementItem(projectId, data) {
  const res = await axios.post(`${API}/projects/${projectId}/management`, data);
  return res.data;
}

export async function updateManagementItem(projectId, itemId, data) {
  const res = await axios.put(`${API}/projects/${projectId}/management/${itemId}`, data);
  return res.data;
}

export async function archiveManagementItem(projectId, itemId) {
  const res = await axios.delete(`${API}/projects/${projectId}/management/${itemId}`);
  return res.data;
}

// ── Weekly Updates ───────────────────────────────────────────────────────────

export async function getWeeklyUpdates(projectId) {
  const res = await axios.get(`${API}/projects/${projectId}/weekly-updates`);
  return res.data;
}

export async function submitWeeklyUpdate(projectId, updateText) {
  const res = await axios.post(`${API}/projects/${projectId}/weekly-updates`, {
    update_text: updateText,
  });
  return res.data;
}

// ── AI Refresh ───────────────────────────────────────────────────────────────

export async function triggerAiRefresh(projectId) {
  const res = await axios.post(`${API}/projects/${projectId}/management/ai-refresh`);
  return res.data;
}

// ── Reports (F-027) ──────────────────────────────────────────────────────────

export async function generateReport(projectId) {
  const res = await axios.post(`${API}/projects/${projectId}/management/generate-report`);
  return res.data;
}

export async function getReportUrl(projectId, reportId) {
  return `${API}/projects/${projectId}/management/report/${reportId}`;
}

// ── Management Settings (F-027) ──────────────────────────────────────────────

export async function getManagementSettings(projectId) {
  const res = await axios.get(`${API}/projects/${projectId}/management/settings`);
  return res.data;
}

export async function updateManagementSettings(projectId, settings) {
  const res = await axios.put(`${API}/projects/${projectId}/management/settings`, settings);
  return res.data;
}
